import { render, staticRenderFns } from "./CreateCarrierPopUp.vue?vue&type=template&id=95c72dd0&scoped=true&"
import script from "./CreateCarrierPopUp.vue?vue&type=script&lang=js&"
export * from "./CreateCarrierPopUp.vue?vue&type=script&lang=js&"
import style0 from "./CreateCarrierPopUp.vue?vue&type=style&index=0&id=95c72dd0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95c72dd0",
  null
  
)

export default component.exports